var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstudos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1562 8.78125C49.6406 12.1406 50.5 16.2031 50.5 20.1094C50.5 33.5469 41.8281 44.5625 29.5625 45.4219C23.2344 46.125 18.4688 42.8438 15.8906 39.4062C11.9062 42.7656 10.4219 46.2031 10.2656 46.5156C9.71875 47.7656 8.3125 48.3906 6.98438 47.8438C5.73438 47.2969 5.10938 45.8906 5.65625 44.5625C7.53125 40.1094 15.8125 28 35.5 28C36.125 28 36.75 27.4531 36.75 26.75C36.75 26.125 36.125 25.5 35.5 25.5C25.2656 25.5 18.0781 28.5469 13.0781 32.1406C13 31.5938 13 31.0469 13 30.5C13 22.2188 19.7188 15.5 28 15.5H34.25C39.1719 15.5 43.4688 12.9219 45.8906 8.70312C46.4375 7.76562 47.6875 7.84375 48.1562 8.78125Z",
    fill: "#F4731D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudos);
export default __webpack_public_path__ + "static/media/estudos.277326918dea2241824d2f8bdb53eaa1.svg";
export { ForwardRef as ReactComponent };